import React, { useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import swal from "sweetalert";
import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import { useNavigate } from "react-router";
import { api_path } from "../shared";
import useDeviceSize from "../hooks/useDeviceSize";
export function ServiceContractDataGrid(props) {
    const [width, height] = useDeviceSize();
    const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
    const onContentReady = useCallback(() => {
      setLoadPanelEnabled(false);
    }, []);
     const [modeSize, setModeSize] = useState('widget');
  const classes = useStyles();
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const [getStatus, setStatus] = useState([]);
  const [selectStatus, setSelectStatus] = useState([]);
  const [getTradLane, setTradLane] = useState([]);
  const [selectTradLane, setSelectTradLane] = useState([]);
  const [getTrad2, setTrad2] = useState([]);
  const [selectTrad2, setSelectTrad2] = useState([]);
  const [getCarrier, setCarrier] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [selectCarrier, setSelectCarrier] = useState([]);
  const [carrierList2, setCarrierList2] = useState([]);

  const [getSpecialFlag, setSpecialFlag] = useState([]);
  const [selectSpecialFlag, setSelectSpecialFlag] = useState([]);

  const [getSpecialFlag2, setSpecialFlag2] = useState([]);
  const [selectSpecialFlag2, setSelectSpecialFlag2] = useState([]);
  const [GET_SC_SEARCHBOX, SET_SC_SEARCHBOX] = useState("");
  const [GET_BL_SEARCHBOX, SET_BL_SEARCHBOX] = useState("");
  const [getLoadGrid, setLoadGrid] = useState();
  const [showComment, setShowComment] = useState(false);
  const handleCloseModal = () => setShowComment(false);
  const handleShowComment = () => setShowComment(true);
  const [showLog, setShowLog] = useState(false);
  const handleCloseLog = () => setShowLog(false);
  const handleShowLog = () => setShowLog(true);
  const [logData, setLogData] = useState([]);
  const navigate = useNavigate();
  const url =
    api_path +
    "/MS_SERVICES_CONTRACT_FORM.php?trade=" +
    selectTradLane +
    "&carrier=" +
    selectCarrier +
    "&sc=" +
    GET_SC_SEARCHBOX +
    "&bl=" +
    GET_BL_SEARCHBOX +
    "&status=1" +
    "&flag=" +
    selectSpecialFlag2 +
    "&load=" +
    getLoadGrid;
  const dataSource = createStore({
    key: "SERVICE_CONTRACT_ID",
    loadUrl: `${url}`,
  });
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const handleCarrierChange = (obj) => {
    setSelectCarrier(obj.value);
    setCarrier({
      value: obj.value,
      label: obj.label,
    });
  };

  useEffect(() => {
    const getCarrierDropdown = async () => {
      const resstate = await fetch(api_path + `/MS_CARRIER.php`);
      const getst = resstate.json();
      setCarrierList(await getst);
      setCarrierList2(await getst);
    };
    getCarrierDropdown().then();
  }, []);

  const handleTradListChange = (obj) => {
    if (obj) {
      setSelectTrad2(obj.value);
      setTrad2({ value: obj.value, label: obj.label });
    } else {
      setSelectTrad2([]);
      setTrad2([]);
    }
  };
  const handleStatusChange = (obj) => {
    setSelectStatus(obj.value);
    setStatus({ value: obj.value, label: obj.label });
  };
  const handleFlagSearchChange = (obj) => {
    setSelectSpecialFlag2(obj.value);
    setSpecialFlag2({ value: obj.value, label: obj.label });
  };
  const handleTradLaneChange = (obj) => {
    setSelectTradLane(obj.value);
    setTradLane({ value: obj.value, label: obj.label });
  };
  const handleSpecialFlagChange = (obj) => {
    setSelectSpecialFlag(obj.value);
    setSpecialFlag({ value: obj.value, label: obj.label });
  };

  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "ServiceContract.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const options = [
    { value: "", label: "ALL" },
    { value: "TP", label: "TP" },
    { value: "NON-TP", label: "NON-TP" },
  ];

  const specialFlagList = [
    { value: "1", label: "Normal" },
    { value: "2", label: "Special" },
    // { value: "3", label: "Promote" },
  ];

  const optionsSpecialFlagList2 = [
    { value: "", label: "All" },
    { value: "1", label: "Normal" },
    { value: "2", label: "Special" },
    // { value: "3", label: "Promote" },
  ];

  const handleClearInputClick = () => {
    setSelectCarrier([]);
    setCarrier([]);
    setTradLane([]);
    setSelectTradLane([]);
    setSelectStatus([]);
    setStatus([]);
    setSpecialFlag2([]);
    setSelectSpecialFlag2([]);
    SET_SC_SEARCHBOX("");
    SET_BL_SEARCHBOX("");
  };
  const onRefreshClick = useCallback(() => {
    setLoadGrid(randomNumberInRange(1, 20));
  }, []);

  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "IS_ACTIVE") {
        if (e.data.IS_ACTIVE == 1) {
          e.cellElement.innerHTML = "🟢";
          e.cellElement.style.cssText = "text-align:center;";
        } else {
          e.cellElement.innerHTML = "⚫";
          e.cellElement.style.cssText = "text-align:center;";
        }
      }
      if (e.column.dataField === "FLAG_NAME" && e.data.SPECIAL_FLAG == 2) {
        e.cellElement.innerHTML =
          "<p class='status9'>" + e.data.FLAG_NAME + "</p>";
      } else if (
        e.column.dataField === "FLAG_NAME" &&
        e.data.SPECIAL_FLAG == 1
      ) {
        e.cellElement.innerHTML =
          "<p class='status0'>" + e.data.FLAG_NAME + "</p>";
      }
      if (e.column.dataField === "CONDITION" && e.data.SPECIAL_FLAG == 2) {
        e.cellElement.style.cssText = "text-align:left;color:red;";
      } else if (
        e.column.dataField === "CONDITION" &&
        e.data.SPECIAL_FLAG == 0
      ) {
        e.cellElement.style.cssText = "text-align:left;";
      }
      if (e.column.dataField === "ORDER_NO") {
        e.cellElement.innerHTML =
          "<p style='color: #000;background-color: #EBEBEB;text-align:center;margin:8px;'><a href='SalesOrderDetail?order_id=" +
          e.row.key +
          "'  title='View Order' target='_blank' style='color: #000;'>" +
          e.data.ORDER_NO +
          "</a></p>";
      }
    }
  };

  return (
    <Container maxWidth="xl">
      <br /> <br />
      <Grid container spacing={2}>
        <label className="head">Services Contract</label>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={1}>
          <label>TRADE</label>
          <Select
            className="multiselect1"
            placeholder="Select"
            value={getTradLane}
            options={options}
            onChange={handleTradLaneChange}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>CARRIER</label>
          <Select
                     className="multiselect2"
            placeholder="Select"
            value={getCarrier}
            options={carrierList}
            onChange={handleCarrierChange}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Services contract No</label>
          <TextField
            size="small"
            name="GET_SC_SEARCHBOX"
            variant="outlined"
            fullWidth
            id="GET_SC_SEARCHBOX"
            value={GET_SC_SEARCHBOX}
            onChange={(e) => SET_SC_SEARCHBOX(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Bullet code</label>
          <TextField
            size="small"
            name="GET_BL_SEARCHBOX"
            variant="outlined"
            fullWidth
            id="GET_BL_SEARCHBOX"
            value={GET_BL_SEARCHBOX}
            onChange={(e) => SET_BL_SEARCHBOX(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>Flag: </label>
          <br />
          <Select
            className="multiselect3"
            placeholder="Select"
            value={getSpecialFlag2}
            options={optionsSpecialFlagList2}
            onChange={handleFlagSearchChange}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <div style={{ paddingTop: 7 + "px" }}>&nbsp;</div>
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="info"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button1>{" "}
          &nbsp;&nbsp;&nbsp;
          <Button1
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={onRefreshClick}
          >
            Refresh data
          </Button1>
        </Grid>
        <Grid item xs={12} sm={2}>
          &nbsp;
        </Grid>
        {/* <Grid
          item
          xs={12}
          sm={12}
          style={{ display: "flex", paddingTop: 27 + "px" }}
          justify="flex-end"
        >
          <Button1
            className="addBtn"
            //disabled={!isButtonDisabled}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleAddButtonClick}
          >
            Add New
          </Button1>
        </Grid> */}
      </Grid>
      <Grid container className={classes.root}>
        <DataGrid
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="SERVICE_CONTRACT_ID"
          onExporting={onExporting}
          onCellPrepared={cellPrepared}
          onContentReady={onContentReady}
          height={height}
          repaintChangesOnly={true}
        >
          {/* <Editing
            mode="batch"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
            changes={state.changes}
            onChangesChange={onChangesChange}
            editRowKey={state.editRowKey}
            onEditRowKeyChange={onEditRowKeyChange}
          />  */}
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column dataField="TRADE_LANE" caption="TRADE" />
          <Column dataField="CARRIER_CODE" caption="CARRIER" />
          <Column
            dataField="SERVICE_CONTRACT_NO"
            caption="SERVICE"
            allowHiding={false}
          />
          <Column
            dataField="BULLET_CODE"
            caption="BULLET"
            allowHiding={false}
          />
          <Column dataField="BOND" />
          <Column dataField="CONDITION" caption="DESCRIPTION" />
          <Column dataField="VALIDITY" caption="VALIDITY" />
          <Column dataField="SPECIAL_FLAG" caption="FLAG" visible={false} />
          <Column dataField="FLAG_NAME" caption="FLAG" />
          <Paging defaultPageSize={50} />
          <LoadPanel enabled={true} />
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
